module.exports = __webpack_public_path__ + "e7d372f7e2656937ddb92ded3fdd17e4.jpg";